module.exports = __webpack_public_path__ + "img/หอยแครง.e5d61307.jpg";